module.exports = __webpack_public_path__ + "static/image-06-b@2x-a5e7e3274e16a7d53022e64c1659648a.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/zinc/image-06-b@2x.png
// module id = 443
// module chunks = 3627797113349 20562973939449 33019919093843